import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import poweredbyJDPImg from "../../assets/images/powered-by-jdp.jpg";

const Footer = () => {
     return (
          <Grid alignItems="center" justifyContent="center" container>
               <Grid item>
                    <Box
                         sx={{
                              maxWidth: 200,
                              fontSize: "12px",
                         }}
                    >
                         <img
                              src={poweredbyJDPImg}
                              alt="Powered by JD Power"
                              style={{ maxWidth: "100%", height: "auto" }}
                         />
                    </Box>
               </Grid>
          </Grid>
     );
};

export default Footer;
